import { useState } from 'react';

import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Button from '@material-ui/core/Button';

import Layout from 'components/Layout';
import { FileListTable, FileUploadDialog } from 'components/FileList';

import { useGetListFiles, useUploadFile } from 'services/CustomDataService';

const CustomData = () => {
  const [uploadOpen, setUploadOpen] = useState(false);
  const { isLoading, isError, data: files } = useGetListFiles();
  const { mutateAsync: uploadFile } = useUploadFile();

  const handleUpload = (file) => {
    uploadFile(file).then(() => {
      setUploadOpen(false);
    });
  };

  return (
    <Layout>
      <Container maxWidth="lg" style={{ margin: 0 }}>
        <Grid container spacing={3} alignItems="flex-start">
          <Grid item xs={12}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h4" as="h1">
                Custom Data
              </Typography>

              <Button
                variant="contained"
                color="primary"
                startIcon={<CloudUploadIcon />}
                onClick={() => setUploadOpen(true)}
              >
                Upload File
              </Button>

              <FileUploadDialog
                isOpen={uploadOpen}
                onClose={() => setUploadOpen(false)}
                onUpload={handleUpload}
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            {isError ? (
              <Typography variant="body1" color="error">
                Error fetching files
              </Typography>
            ) : (
              <FileListTable
                files={files?.results || []}
                totalFiles={files?.total || 0}
                isLoading={isLoading}
              />
            )}
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default CustomData;
